import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  type AcquiredPropertiesResponse,
  type AcquiredPropertySearch,
} from "../types";
import {
  ACQUIRED_PROPERTIES_ENDPOINT,
  getAcquiredProperties,
} from "../api/getAcquiredProperties";
import { notifySearchError } from "../utils/searchError";
import { makeSearchParams } from "../utils/searchState";

export const useAcquiredProperties = (
  search: AcquiredPropertySearch,
  userId: string,
  isSharable: boolean,
  enabled = true,
  revalidateIfStale = true
): SWRResponse<AcquiredPropertiesResponse, Error> => {
  const { apiClient } = useApiClient();
  const params = makeSearchParams(search);
  return useSWR<AcquiredPropertiesResponse, Error>(
    enabled && userId
      ? [ACQUIRED_PROPERTIES_ENDPOINT, userId, isSharable, params]
      : null,
    async ([, , , searchParams]: [string, string, boolean, typeof params]) =>
      await getAcquiredProperties(apiClient, searchParams),
    {
      keepPreviousData: false,
      onError: notifySearchError,
      shouldRetryOnError: false,
      revalidateIfStale,
      revalidateOnFocus: true,
      refreshWhenHidden: false,
      refreshInterval: (data) =>
        data?.list.some((row) =>
          row.documents.some((document) => document.status === null)
        )
          ? 30_000
          : 0,
    }
  );
};
